import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { CoverageDisplayEnum } from '@app/core';
import { PolicyValidityStatusCodeEnum, PurchasedProductInterface } from 'outshared-lib';
import { CommonModule } from '@angular/common';
import { DateFormatPipeModule } from '@app/shared/pipes/date-format/date-format.module';
import {
    WucDisplayTableComponent, WucDisplayTableLabelComponent,
    WucDisplayTableRowComponent,
    WucDisplayTableValueComponent, WucPriceModule,
    WucTabsetItemModule,
    WucTabsetModule,
} from '@inshared/website-ui-components';
import { InsuranceCoverageDataListComponent } from './insurance-coverage-data-list';

@Component({
    selector: 'ins-insurance-coverage-data',
    templateUrl: 'insurance-coverage-data.component.html',
    standalone: true,
    imports: [
        CommonModule,
        DateFormatPipeModule,
        WucTabsetModule,
        WucTabsetItemModule,
        WucDisplayTableValueComponent,
        WucDisplayTableRowComponent,
        WucDisplayTableComponent,
        WucDisplayTableLabelComponent,
        WucPriceModule,
        InsuranceCoverageDataListComponent,
    ],
})
export class InsuranceCoverageDataComponent implements AfterViewInit {
    @Input() public purchasedProduct!: PurchasedProductInterface;

    public validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
    public coverageDisplayEnum = CoverageDisplayEnum;
    public selectedTabIndex: number = 0;

    // eslint-disable-next-line no-useless-constructor
    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    public ngAfterViewInit(): void {
        // This is a workaround for content not loading correctly after load
        setTimeout((): void => {
            this.changeDetectorRef.detectChanges();
        }, 0);
    }
}
